import axios from 'axios'
import store from './store';
import router from './router';

export default ({
  axiosinstance: axios.create({
    //baseUrl: "https://localhost:5004/api/",
    baseUrl: "https://api.fcc-slo.eu/",
    timeout: 5000,
    headers: {
      'X-Auth-Token': 'f2b6637ddf355a476918940289c0be016a4fe99e3b69c83d',
      'Content-Type': 'application/json'
    }
  }),
  baseUrl: "https://api.fcc-slo.eu/",
  //baseUrl: "https://localhost:5004/",
  login: function (credentials) {
    return new Promise((resolve, reject)=>{
      console.log("fccapi login")
      axios.post(`${this.baseUrl}api/login`, credentials)
        .then((result) => {
          resolve(result.data.auth_token)
        })
        .catch((result) => {
          console.log("Login error")
          reject(result)
        });
    });
  },
  get: function (url) {
    const token = store.getters['token'];
    store.dispatch('setLoading', true);
    return new Promise((resolve, reject)=>{
      axios.get(`${this.baseUrl}api/${url}`, {headers: {Authorization: `Bearer ${token}`}})
        .then(r => {
          store.dispatch('setServerUnavailable', false);
          store.dispatch('setLoading', false);
          resolve(r);
        })
        .catch(e => {
          store.dispatch('setLoading', false);
          reject(e);
          if(e && e.response && e.response.status == 401) {
            store.dispatch('setServerUnavailable', true);
            store.dispatch('logout'); // TODO: renew token
            router.push('/login');
          }
          else if (!e.status) {
            store.dispatch('setServerUnavailable', true);
          }
          else store.dispatch('setServerUnavailable', false);
        });
    })
  },
  delete: function (url) {
    const token = store.getters['token'];
    store.dispatch('setLoading', true);
    return new Promise((resolve, reject)=>{
      axios.delete(`${this.baseUrl}api/${url}`, {headers: {Authorization: `Bearer ${token}`}})
        .then(r => {
          store.dispatch('setServerUnavailable', false);
          store.dispatch('setLoading', false);
          resolve(r);
        })
        .catch(e => {
          store.dispatch('setLoading', false);
          reject(e);
          if(e && e.response && e.response.status == 401) {
            store.dispatch('setServerUnavailable', true);
            store.dispatch('logout'); // TODO: renew token
            router.push('/login');
          }
          else if (!e.status) {
            store.dispatch('setServerUnavailable', true);
          }
          else store.dispatch('setServerUnavailable', false);
        });
    })
  },
  post: function (url, data) {
    const token = store.getters['token'];
    store.dispatch('setLoading', true);
    return new Promise((resolve, reject)=>{
      axios.post(`${this.baseUrl}api/${url}`, data, {headers: {Authorization: `Bearer ${token}`}})
        .then(e => {
          store.dispatch('setServerUnavailable', false);
          store.dispatch('setLoading', false);
          resolve(e);
        })
        .catch(e => {
          store.dispatch('setLoading', false);
          reject(e);
          if(e && e.response && e.response.status == 401) {
            store.dispatch('setServerUnavailable', true);
            store.dispatch('logout'); // TODO: renew token
            router.push('/login');
          }
          else if (!e.status) {
            store.dispatch('setServerUnavailable', true);
          }
          else store.dispatch('setServerUnavailable', false);
        });
    });
  },
  upload: function(url, data){
    const token = store.getters['token'];
    store.dispatch('setLoading', true);
    return new Promise((resolve, reject)=>{
      axios.post(`${this.baseUrl}api/${url}`, data, {
          headers: {Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data'}
        })
        .then(e => {
          store.dispatch('setServerUnavailable', false);
          store.dispatch('setLoading', false);
          resolve(e);
        })
        .catch(e => {
          store.dispatch('setLoading', false);
          reject(e);
          if(e && e.response && e.response.status == 401) {
            store.dispatch('setServerUnavailable', true);
            store.dispatch('logout'); // TODO: renew token
            router.push('/login');
          }
          else if (!e.status) {
            store.dispatch('setServerUnavailable', true);
          }
          else store.dispatch('setServerUnavailable', false);
        });
    });
  },
  competitionGet: function (url) {
    const cid = store.getters['competitionId'];
    return this.get(`competitions/${cid}/${url}`);
  }
})